export default __webpack_public_path__ + "static/media/stabs-hits-061.03ca1569.mp3";